import Axios from "axios";
import { storage } from "./storage";

class BlogImageUploadAdapter {
  constructor(loader) {
    this.loader = loader;
    this.cancelled = false;
  }

  async upload() {
    const file = await this.loader.file;
    if (this.cancelled) throw new Error("Image upload cancelled.");

    const token = await storage.load("token");
    if (!token) throw new Error("Authentication is required to upload an image.");

    const formData = new window.FormData();
    formData.append("upload", file);

    const response = await Axios.post("/upload_blog_content_image", formData, {
      headers: { "x-auth": token },
    });
    const url = response.data?.url;
    if (!url) throw new Error("The image upload did not return a URL.");

    return { default: url };
  }

  abort() {
    this.cancelled = true;
  }
}

function BlogImageUploadPlugin(editor) {
  const fileRepository = editor.plugins.get("FileRepository");

  fileRepository.createUploadAdapter = (loader) =>
    new BlogImageUploadAdapter(loader);
}

export { BlogImageUploadPlugin };
